export default __webpack_public_path__ + "static/media/bg5.8716f7c9.png";